import './StepCards.css';
import React from 'react';
import { get } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SingleStepCard } from './SingleStepCard/SingleStepCard';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
const TABLET_BREAKPOINT = {
  max: 767,
  min: 0
};
const TABLE_PORTRAIT_BREAKPOINT = {
  max: 1282,
  min: TABLET_BREAKPOINT.max + 1
};
const DESKTOP_BREAKPOINT = {
  max: 1482,
  min: TABLE_PORTRAIT_BREAKPOINT.max + 1
};
const EXTRA_BREAKPOINT = {
  max: 10000,
  min: DESKTOP_BREAKPOINT.max + 1
};
const StepsCards = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const items = get(props.fields, "data.item.cards", []);
  const isList = props.params.variant === "ListVariation";
  let eventsAnalytics = get(props.fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const renderStepCard = item => {
    if (item.stepNumber && item.stepNumber.jss) {
      return /*#__PURE__*/React.createElement(SingleStepCard, {
        key: item.stepNumber.jss.value,
        num: item.stepNumber.jss,
        title: item.title.jss,
        description: item.description.jss,
        link: item.cTALink.jss,
        ctaText: item.ctaLabel.jss,
        onLinkClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["readMoreAnalytics"], props.params), [item.title.jss.value, item.ctaLabel.jss.value])
      });
    } else {
      return null;
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isGreyBackgroundStyle: Boolean(props.params['Is Grey']),
    anchorUrlParameter: props.params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "steps module-group"
  }, items.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `steps__elements ${items.length > 2 ? "steps__elements--3-columns" : "steps__elements--2-columns"} ${isList ? "steps__elements--is-list" : ""}`
  }, items.map(item => renderStepCard(item))), isList && /*#__PURE__*/React.createElement("div", {
    className: "steps__carousel"
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, _ref => {
    let {
      renderDots,
      renderCarousel
    } = _ref;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(items.map(item => renderStepCard(item)), {
      responsive: {
        extra: {
          breakpoint: EXTRA_BREAKPOINT,
          items: items.length > 4 ? 4 : items.length
        },
        desktop: {
          breakpoint: DESKTOP_BREAKPOINT,
          items: items.length > 3 ? 3 : items.length
        },
        table_portrait: {
          breakpoint: TABLE_PORTRAIT_BREAKPOINT,
          items: items.length > 2 ? 2 : items.length
        },
        tablet: {
          breakpoint: TABLET_BREAKPOINT,
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "module-group no-padding-bottom"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots())));
  })))));
};
export default StepsCards;
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    isGreyBackgroundStyle,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${isGreyBackgroundStyle ? `${commonStyles}--grey` : ""} ${rtl ? rtlStyles : ltrStyles}`,
    anchorUrlParameter: anchorUrlParameter
  }, children);
};
const commonStyles = "cv427bd";
const ltrStyles = "l17er0py";
const rtlStyles = "r3ehwxs";